import {eventPrevented} from '../../../../../utils/eventPrevented';
import {removeItemFromHomepage} from '../../../actions/dialogs';
import {showFormClientSideMessage} from '../../../../Form/actions/messages';
import {priority} from '@priority-software/priority-proto-api/lib';
import texts from '../../../texts';

type HookProps = {
    exec: string;
    title: string;
    mymenu: string;
    type: string;
    ename: string;
    etype: string;
    isDisabled: boolean;
};

export const useEntityHandlers = ({
    mymenu,
    exec,
    type,
    ename,
    etype,
    title,
    isDisabled
}: HookProps) => {
    const runEntity = (menuType, fatexec, e) => {
        if (isDisabled) {
            showFormClientSideMessage('', priority.netitems.shared.Message.Type.Error, {
                title: texts.no_privilege_tile_msg
            });
            return;
        }
        e.stopPropagation();
        (window as any)?.personal_item_menue_click(
            menuType,
            fatexec, // what's the ? "fatexec"
            Number(exec),
            etype,
            ename,
            type,
            e
        );
    };

    const onCounterClick = e => {
        eventPrevented(e, true);
        runEntity(7, 0, e);
    };

    const openFormSearch = e => {
        eventPrevented(e, true);
        runEntity(10, 0, e);
    };

    const openFormNewRecord = e => {
        eventPrevented(e, true);
        runEntity(9, 0, e);
    };

    const openEntity = e => {
        eventPrevented(e, true);
        runEntity(mymenu, '-200', e);
    };

    const deleteTile = async e => {
        eventPrevented(e, true);
        await removeItemFromHomepage(exec, title);
    };

    return {
        openEntity,
        openFormNewRecord,
        openFormSearch,
        deleteTile,
        onCounterClick
    };
};
